import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import { transformResultsToCompProfileData } from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function Risks({ susFinInnoRisk = [] }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const allMetrics = [
    // { key: "key_risk", label: "Key Risk" },
    { key: "priority", label: "Priority" },
    { key: "mitigation", label: "Mitigation" },
  ];

  useEffect(() => {
    const dataArray = Array.isArray(susFinInnoRisk)
      ? susFinInnoRisk
      : [susFinInnoRisk];

    const cleanedData = dataArray.map((item) => {
      const { sustainability, finance, innovation, ...rest } =
        item.response || {};
      return { ...item, response: rest };
    });

    const transformed = transformResultsToCompProfileData(cleanedData);
    setTabData(transformed);

    setTableBelowDescription(
      <ParsedTextWithLinks
        text={susFinInnoRisk?.[0]?.response?.tableComments || ""}
      />
    );
  }, [susFinInnoRisk]);

  const actions = [
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Risks"
      subtitle=""
      data={tabData}
      metrics={allMetrics}
      rowIdentifier="key_risk"
      belowTableDescription={tableBelowDescription}
      actions={actions}
    />
  );
}

export default Risks;
